import { MetricTile } from './../metrics/metric-tile';
import { DashboardMetricCategory } from '@liquitics/transaction';

export class DashboardMetricSet {
    type: 'Single' | 'Top3' | 'Placeholder';
    initialized: boolean;
    icon: string;
    label: string;
    name: string;
    metrics: string[];
    values: any[];
    dates: string[];
    subType?: string;
    category?: DashboardMetricCategory;
    categoryIndex?: number;
    underlyingData?: any;
    fontSize?: string;
}



export interface DashboardMetricTiles<T> {
    generateDashboardMetricsSets(data: T[]): DashboardMetricSet[];
    initLabelTiles(dashboardMetricSetData: DashboardMetricSet[]): MetricTile<DashboardMetricSet>[];
    initTiles(dashboardMetricSetData: DashboardMetricSet[]): MetricTile<DashboardMetricSet>[];
    blankTiles(riskMetricTiles: MetricTile<DashboardMetricSet>[]): any[];
}
